import { useEffect, useState } from 'react';
import styles from './VideoPrize.module.css';

import volumeSVG from '../assets/svgs/volume.svg';
import volumeSlashSVG from '../assets/svgs/volume-slash.svg';

function VideoPrize(props) {
	const { src, name } = props
	const [videoReady, setVideoReady] = useState(false)
	const [isHorizontal, setIsHorizontal] = useState(false)
	const [isShowName, setIsShowName] = useState(false)
	const [isFadeName, setIsFadeName] = useState(false)
	const [isMuted, setIsMuted] = useState(true)

	const volumeSrc = isMuted
		?
		volumeSlashSVG
		:
		volumeSVG

	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth
			const height = window.innerHeight
			const ratio = width / height

			if (ratio < 16 / 9) {
				setIsHorizontal(false)
			} else {
				setIsHorizontal(true)
			}

			if (width < 768 * window.devicePixelRatio) {
				setIsMuted(true)
			} else {
				setIsMuted(false)
			}
		}
		handleResize()
		window.addEventListener('resize', handleResize)

		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	const handleTimeUpdate = (e) => {
		if (e.target.currentTime < 16) {
			setIsShowName(false)
			setIsFadeName(false)
		} else if (e.target.currentTime >= 16 && e.target.currentTime < 27) {
			setIsShowName(true)
			setIsFadeName(true)
		} else {
			setIsShowName(false)
			setIsFadeName(true)
		}
	}

	const handleToggleMuted = () => {
		setIsMuted(!isMuted)
	}

	return (
		<>
			<div className={styles.toggleMuted} onClick={handleToggleMuted}>
				<img src={volumeSrc} alt='Toggle Muted' />
			</div>
			{
				name &&
				<div className={`${styles.videoName} ${isHorizontal ? styles.horizontal : ''} ${isShowName ? styles.show : styles.hide} ${isFadeName ? styles.fade : ''}`}>
					{name}
					<div className={styles.participant}>Participant</div>
				</div>
			}
			<video
				className={`${styles.video} ${videoReady ? styles.show : ''}`}
				src={src}
				muted={isMuted}
				autoPlay={true}
				controls={false}
				loop={true}
				playsInline={true}
				onCanPlay={() => setVideoReady(true)}
				onTimeUpdate={handleTimeUpdate}
			></video>
		</>

	)
}

export default VideoPrize